import {
  CreateCustomAlertRequest,
  UpdateCustomAlertRequest,
} from "../models/customAlert";
import { AxiosHttpClient } from "./AxiosHttpService";

export class CustomAlertService {
  // Récupérer toutes les alertes de l'utilisateur avec pagination
  static getCustomAlerts = (page: number, pageSize: number = 10) => {
    return AxiosHttpClient.get<any>("api/v1/docuveritas/custom-alerts/page", {
      criteriaList: "",
      pageNumber: page - 1,
      pageSize: pageSize,
      sort: "creationDateTime",
      order: "desc",
    });
  };

  // Créer une nouvelle alerte personnalisée
  static createCustomAlert = (alertData: CreateCustomAlertRequest) => {
    return AxiosHttpClient.post<any>(
      "api/v1/docuveritas/custom-alerts",
      alertData
    );
  };

  // Mettre à jour une alerte existante
  static updateCustomAlert = (
    alertId: string,
    alertData: UpdateCustomAlertRequest
  ) => {
    return AxiosHttpClient.put<any>(
      `api/v1/docuveritas/custom-alerts/${alertId}`,
      alertData
    );
  };

  // Supprimer une alerte
  static deleteCustomAlert = (alertId: string) => {
    return AxiosHttpClient.delete<any>(
      `api/v1/docuveritas/custom-alerts/${alertId}`
    );
  };

  // Activer/Désactiver une alerte
  static toggleCustomAlert = (alertId: string, isActive: boolean) => {
    return AxiosHttpClient.put<any>(
      `api/v1/docuveritas/custom-alerts/${alertId}/toggle`,
      { isActive }
    );
  };

  // Récupérer l'historique paginé des notifications d'alertes reçues
  static getNotificationHistory = (page: number, pageSize: number = 5) => {
    return AxiosHttpClient.get<any>(
      "api/v1/docuveritas/custom-alerts/notifications/history",
      {
        pageNumber: page - 1,
        pageSize: pageSize,
        sort: "sentAt",
        order: "DESC",
      }
    );
  };
}
